import { CalendarDays, Flame, House, Trophy, User } from 'lucide-react';
import { SITE } from '../config.ts';
import { Link, useLocation } from '../lib/router.tsx';
import { useSession } from '../lib/session.ts';
import { openAuth } from '../lib/ui.ts';

export function Logo() {
  return (
    <Link to="/" className="logo" aria-label="ChessBut home">
      <img src="/brand/logo.svg" alt="ChessBut" />
    </Link>
  );
}

export function Header() {
  const { me } = useSession();
  return (
    <header className="topbar">
      <Logo />
      <div className="row">
        {me && me.streak.current > 0 && (
          <Link to="/you" className={`chip is-streak ${me.streak.playedToday ? '' : 'is-pending'}`} title={me.streak.playedToday ? 'Daily streak' : 'Finish a game of today’s variant to keep your streak'}>
            <Flame className="icon sm" aria-label="Streak" /> <span className="num">{me.streak.current}</span>
          </Link>
        )}
        {me && me.today.points > 0 && (
          <Link to="/leaderboard" className="chip is-points">
            <span className="num">{me.today.points}</span> pts
          </Link>
        )}
        {me?.guest && !(me.streak.current > 0 || me.today.points > 0) && (
          <button className="chip" onClick={() => openAuth('signup')}>
            Sign in
          </button>
        )}
      </div>
    </header>
  );
}

const NAV = [
  { to: '/', label: 'Play', icon: House, match: (p: string) => p === '/' },
  { to: '/days', label: 'Days', icon: CalendarDays, match: (p: string) => p === '/days' },
  { to: '/ranks', label: 'Ranks', icon: Trophy, match: (p: string) => p.startsWith('/leaderboard') || p.startsWith('/ranks') },
  { to: '/you', label: 'You', icon: User, match: (p: string) => p === '/you' },
];

export function BottomNav() {
  const { path } = useLocation();
  return (
    <nav className="navbar" aria-label="Main">
      {NAV.map(({ to, label, icon: Icon, match }) => (
        <Link key={to} to={to} aria-current={match(path) ? 'page' : undefined}>
          <Icon className="icon" />
          {label}
        </Link>
      ))}
    </nav>
  );
}

export function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-links">
        <Link to="/about">About</Link>
        <Link to="/ideas">Suggest a variant</Link>
        <Link to="/stats">Stats</Link>
        <Link to="/privacy">Privacy</Link>
        {SITE.instagram && (
          <a href={SITE.instagram} target="_blank" rel="noreferrer">
            Instagram
          </a>
        )}
      </div>
      <p>
        Real chess. One ridiculous twist. Every day. · A <a href={SITE.studio.url}>{SITE.studio.name}</a> game
      </p>
    </footer>
  );
}
